import { Component, OnInit } from '@angular/core';
import { DirectoryService } from '../../../../services/directory.service';
import { UrlService } from '../../../../services/url.service';
import { AbstractListComponent } from '../abstract-list.component';
import { EmptyRowService } from '../../../../services/empty-row.service';
import { IResidentPatch } from '../../../../types/api-response/building/resident-patch';

const actionTitles = {
    create: 'Move In',
    delete: 'Move Out',
    update: 'Update'
};

@Component({
    selector: 'updates-list',
    templateUrl: './updates-list.component.html',
    styleUrls: ['./updates-list.component.scss']
})
export class UpdatesListComponent extends AbstractListComponent implements OnInit {

    data: IResidentPatch[];

    actionTitles = actionTitles;

    constructor(
        public directoryService: DirectoryService,
        public urlService: UrlService,
        public emptyRowService: EmptyRowService
    ) {
        super(directoryService, urlService, emptyRowService);
    }

    ngOnInit() {
        super.ngOnInit();

        this.s.push(this.directoryService.onDataReceived.subscribe((response) => {
            const query = this.urlService.getQueryParamsJson();
            if (response.id !== 'updates') {
                return;
            }

            this.data = response.data.entities || [];
            this.emptyRowService.fillEmptyRow();

            if (!(query.hasOwnProperty('building_id') || query.hasOwnProperty('query')) && this.data.length === 0) {
               this.urlService.setQueryParams('residents');
            }
        }));
    }

    openApprovalModal(data) {
        this.directoryService.userUpdateModalData = data;
    }

    /**
     * Returns patched fields description
     *
     * @param patch
     */
    public getPatchDescription(patch: IResidentPatch): string {
        const parts = [];
        let isPatchedProfile = false;

        // Patched name, photo or date of birth
        if(patch.userProfile && (
            typeof patch.userProfile.fullName === 'string' ||
            typeof patch.userProfile.photo === 'string' ||
            typeof (patch.userProfile as any).avatar === 'string' || // fix that bug and remove hack
            typeof patch.userProfile.dateOfBirth === 'string'
        )) {
            isPatchedProfile = true;
        }

        if(isPatchedProfile || Array.isArray(patch.addresses) || Array.isArray(patch.phones)) {
            parts.push('Profile');
        }

        if(patch.userProfile && Array.isArray(patch.userProfile.emergencyContacts)) {
            parts.push('Emergency Contacts');
        }

        if(Array.isArray(patch.vehicles)) {
            parts.push('Vehicles');
        }

        if(Array.isArray(patch.pets)) {
            parts.push('Pets');
        }

        return parts.join(', ');
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/directory/list/updates-list/updates-list.component.ts